import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Homepage from "./containers/Homepage/Homepage";
import Menu from "./containers/Menu/Menu.jsx";
class App extends Component{

  render(){
    return (
      <div>
        <Router>
            <Route exact path="/" component={Homepage}/>
            <Route exact path="/meniu" component={Menu}/>
            
        </Router>
      </div>
    );
  }
}



export default App;
